/* eslint react-hooks/exhaustive-deps: "warn" */
import { useCallback, useRef } from 'react';

import cn from 'classnames';

import { clearTimeoutIfExists } from 'libs/node';

import { useStateHandlers } from 'hooks/useStateHandlers';
import { useUnMount } from 'hooks/useUnMount';

import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './HeaderMenuDropdown.module.scss';

import type { HeaderMenuDropdownProps } from './HeaderMenuDropdown.types';

export const HeaderMenuDropdown = ({ label, loading, children, sidebar, className, wide }: HeaderMenuDropdownProps) => {
  const [{ show }, setState] = useStateHandlers({ show: false });
  const closeTimer = useRef<NodeJS.Timeout | undefined>(undefined);

  const onMouseEnter = useCallback(() => {
    if (closeTimer.current) {
      clearTimeoutIfExists(closeTimer.current);
    }

    setState({ show: true });
  }, [setState]);

  const onMouseLeave = useCallback(() => {
    closeTimer.current = setTimeout(() => setState({ show: false }), 150);
  }, [setState]);

  const onClose = useCallback(() => setState({ show: false }), [setState]);

  useUnMount(() => clearTimeoutIfExists(closeTimer.current));

  return (
    <div
      className={cn(styles.wrapper, show && styles.open, !sidebar && styles.noSidebar, wide && styles.wide, className)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className={cn(styles.label, loading && styles.labelLoading)}>
        {label}
        <Icon type="arrow-2" />
      </div>

      <div className={styles.panel}>
        <div className={styles.main}>
          <div className={styles.content}>{children(onClose)}</div>
        </div>

        {sidebar && <aside className={styles.sidebar}>{sidebar}</aside>}
      </div>
    </div>
  );
};
